import React, { Component } from 'react';
import logo from '../sources/images/everybill-logo-ko.svg';

export default class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            home: '/home',
            about: '/about',
            solutions: '/solutions',
            resources: '/resources',
            contact: '/contact',
            search: '/search',
            demo: '/demo',
            portal: '/automated-consumer-portal',
            selfpay: '/self-pay-websites',
            automated: '/automated-phone-systems',
            currentYear: '',
            backgroundImage: {}
        }
    }

    componentDidMount() {
        this.getYear();
    }

    getYear = () => {
        var date = new Date();
        var year = date.getFullYear();
        this.setState({currentYear: year});
    }

    render() {
        return (
            <div style={{
                backgroundColor: 'black',
            }}>
                <div className="footer-logo">
                    <img className="logo" src={ logo } alt=""/>
                    {/* <span style={{fontSize: '32px', verticalAlign: 'sub', paddingLeft: '5px', color: '#fff'}}>EveryBill</span> */}
                    {/* <h1 style={{color: 'white'}}><strong>EveryBill</strong></h1> */}
                </div>
                <div>
                    <div className="footer">
                        <div className="mobile-hidden">
                            <h5 style={{color: 'white', fontSize: '18px', fontFamily: 'Source Code Pro'}}><strong>ABOUT</strong></h5>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\about">Company Information</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\about">Careers</a>
                            </div>
                        </div>
                        <div className="mobile-hidden">
                            <h5 style={{color: 'white', fontSize: '18px', fontFamily: 'Source Code Pro'}}><strong>SOLUTIONS</strong></h5>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\automated-consumer-portal">Automated consumer portal</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\self-pay-websites">Self-pay websites</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\automated-phone-systems">Automated phone systems</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\demo">Request a Demo</a>
                            </div>
                        </div>
                        {/* <div className="mobile-hidden">
                            <h5 style={{color: 'white'}}><strong>Resources</strong></h5>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a style={{textDecorationLine: 'none', color: 'white'}} href="">News and updates</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a style={{textDecorationLine: 'none', color: 'white'}} href="">Articles</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a style={{textDecorationLine: 'none', color: 'white'}} href="">Events</a>
                            </div>
                        </div> */}
                        <div className="mobile-hidden">
                            <h5 style={{color: 'white', fontSize: '18px', fontFamily: 'Source Code Pro'}}><strong>CONTACT</strong></h5>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\contact">Hours of operation</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\contact">Customer service</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\contact">Submit a support ticket</a>
                            </div>
                        </div>
                        <div>
                            <h5 style={{color: 'white', fontSize: '18px', fontFamily: 'Source Code Pro'}}><strong>LEGAL NOTICES</strong></h5>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\privacy-policy">Privacy policy</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\customer-agreement">Customer agreement</a>
                            </div>
                            <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a className="footer-text" style={{fontSize: '18px'}} href="\site-terms">Terms of use</a>
                            </div>
                            {/* <div style={{paddingBottom: '5px', paddingTop: '5px'}}>
                                <a style={{textDecorationLine: 'none', color: 'white'}} href="">Accessibility notice</a>
                            </div> */}
                        </div>
                    </div>
                    <div style={{backgroundColor: '#000'}}>
                        <div className="custom-divider">
                            <hr style={{borderColor: 'dimgray'}}></hr>
                        </div>
                    </div>
                    <div style={{padding: '50px', paddingTop: '1px', paddingLeft: '10.5%'}}>
                        <span style={{color: 'white'}}>© {this.state.currentYear} EveryBill, LLC. All rights reserved.</span>
                    </div>
                </div>
            </div>
        )
    }
}
